/**
 * HTTP client for the Worker admin audit-log surface (`/v1/admin/audit`).
 * Cookie-credentialed + 404-gated like the other admin surfaces.
 */
import { createAdminRequest, type AdminResult } from './admin-fetch.js';

export type { AdminResult } from './admin-fetch.js';

const request = createAdminRequest('/v1/admin/audit');

export interface AuditEntry {
  id: string;
  admin_user_id: string;
  action: string;
  provider_id: string | null;
  key_id: string | null;
  metadata: Record<string, unknown> | null;
  at: string;
}

export function listAudit(limit = 100): Promise<AdminResult<{ entries: AuditEntry[] }>> {
  // No trailing slash before the query (Hono sub-app `GET /` matches the
  // slash-less mount path only).
  return request(limit === 100 ? '' : `?limit=${encodeURIComponent(String(limit))}`);
}
